module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "woyaofankui"
  }, [_c('div', {
    staticClass: "fk-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fankuiwenti')))]), _vm._v(" "), _c('div', {
    staticClass: "fk-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingmiaoshuniyaofankuidewenti'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fk-box-img"
  }, [_vm._l((_vm.imagesList), function(image, index) {
    return _c('div', {
      key: image.id,
      staticClass: "fk-box-img-item"
    }, [(image.status === 'success') ? _c('img', {
      staticClass: "fk-box-img-item-img1",
      attrs: {
        "src": image.url,
        "alt": "反馈图片"
      }
    }) : (image.status === 'uploading') ? _c('div', {
      staticClass: "uploading-indicator"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangchuanzhong')) + "...")])]) : _c('div', {
      staticClass: "error-indicator"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangchuanshibai')))])]), _vm._v(" "), (image.status === 'success') ? _c('img', {
      staticClass: "delImg",
      attrs: {
        "src": require("../../assets/image/img_sc.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delImage(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.imagesList.length < 4) ? _c('img', {
    staticClass: "fk-box-img-img",
    attrs: {
      "src": require("../../assets/image/tianjia_tupian@2x.png"),
      "alt": "添加图片"
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fk-btn"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submitFeedbackForm
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e30e120e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/woyaofankui/woyaofankui.vue
// module id = 1004
// module chunks = 1